import DEFAULT_SWITCH_CLASS_NAME from '../../constants/switch';
import FingoMuiSwitch from '../../fingo/components/MuiSwitch';

const defaultSwitch = ({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.secondary.A400,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.secondary.A400,
      },
    },
    '& + .MuiSwitch-track': {
      backgroundColor: theme.palette.gray.A600,
    },
  },
});

const MuiSwitch = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiSwitch.styleOverrides.root({ theme }),
      [`&.${DEFAULT_SWITCH_CLASS_NAME}`]: defaultSwitch({ theme }),
    }),
  },
};

export default MuiSwitch;
